

// const PROJECT_ID = 'portfolio-e79b8-5854c';
// export const API_KEY    = 'AIzaSyDLsmnqt6wth0b3hZYrnllXnJIcjUaK8Uc';
// export const REST_BASE  = `https://firestore.googleapis.com/v1/projects/${PROJECT_ID}/databases/(default)/documents`;

// // ── Deserializer: Firestore REST format → JS ──────────────────────────────────

// function fromValue(v) {
//   if (!v) return null;
//   if ('stringValue'  in v) return v.stringValue;
//   if ('integerValue' in v) return Number(v.integerValue);
//   if ('doubleValue'  in v) return Number(v.doubleValue);
//   if ('booleanValue' in v) return v.booleanValue;
//   if ('nullValue'    in v) return null;
//   if ('arrayValue'   in v) return (v.arrayValue.values || []).map(fromValue);
//   if ('mapValue'     in v) return fromFields(v.mapValue.fields || {});
//   return null;
// }

// function fromFields(fields) {
//   const obj = {};
//   for (const [k, v] of Object.entries(fields)) obj[k] = fromValue(v);
//   return obj;
// }

// // ── Core fetch helpers ────────────────────────────────────────────────────────

// async function fetchCollection(col, orderBy = null) {
//   let url = `${REST_BASE}/${col}?key=${API_KEY}`;
//   if (orderBy) url += `&orderBy=${encodeURIComponent(orderBy)}`;
//   const res = await fetch(url);
//   if (res.status === 404) return [];
//   if (!res.ok) throw new Error(`Firestore ${col}: ${res.status}`);
//   const json = await res.json();
//   if (!json.documents) return [];
//   return json.documents.map(d => ({
//     id: d.name.split('/').pop(),
//     ...fromFields(d.fields || {}),
//   }));
// }

// async function fetchDocument(col, docId) {
//   const url = `${REST_BASE}/${col}/${docId}?key=${API_KEY}`;
//   const res = await fetch(url);
//   if (!res.ok) return null;
//   const json = await res.json();
//   return { id: docId, ...fromFields(json.fields || {}) };
// }

// // ── Public fetch functions ────────────────────────────────────────────────────

// export async function fetchProjects() {
//   return fetchCollection('projects', 'order');
// }

// export async function fetchSkillGroups() {
//   const data = await fetchCollection('skillGroups');
//   return data.map(g => ({
//     ...g,
//     items: (g.items || []).map(item =>
//       Array.isArray(item) ? item : [item.name, item.level]
//     ),
//   }));
// }

// export async function fetchExperiences() {
//   return fetchCollection('experiences', 'order');
// }

// export async function fetchAbout() {
//   return fetchDocument('about', 'main');
// }

// export async function fetchCertificates() {
//   return fetchCollection('certificates', 'order');
// }
// export async function fetchReviews() {
//   return fetchCollection('reviews', 'order');
// }
// // ── Theme: reads the `theme/colors` document ──────────────────────────────────

// export async function fetchTheme() {
//   const url = `${REST_BASE}/theme/colors?key=${API_KEY}`;
//   const res = await fetch(url);
//   if (res.status === 404) return null;
//   if (!res.ok) return null;
//   const json = await res.json();
//   const fields = json.fields || {};
//   return Object.fromEntries(
//     Object.entries(fields).map(([k, v]) => [k, v.stringValue || ''])
//   );
// }

// // ── Projects Outro Quote: reads `projectsMeta/quote` document ─────────────────
// // Document shape stored in Firestore:
// //   { lines: ["line one,", "line two."], attribution: "— Someone" }
// //
// // Returns: { lines: string[], attribution: string }
// // Falls back to hardcoded defaults if the document doesn't exist yet.

// const DEFAULT_QUOTE = {
//   lines:       ['about what you add,', 'but what you leave out.'],
//   attribution: '',
// };

// export async function fetchProjectsQuote() {
//   const url = `${REST_BASE}/projectsMeta/quote?key=${API_KEY}`;
//   const res = await fetch(url);
//   if (res.status === 404) return DEFAULT_QUOTE;
//   if (!res.ok)            return DEFAULT_QUOTE;
//   const json   = await res.json();
//   const fields = json.fields || {};
//   const data   = fromFields(fields);

//   const lines       = Array.isArray(data.lines) ? data.lines.filter(Boolean) : DEFAULT_QUOTE.lines;
//   const attribution = typeof data.attribution === 'string' && data.attribution.trim()
//     ? data.attribution
//     : DEFAULT_QUOTE.attribution;

//   return { lines, attribution };
// }

// // ── Static assets (not in Firestore) ─────────────────────────────────────────

// export const IMG = {
//   neural:   'https://media.giphy.com/media/26tn33aiTi1jkl6H6/giphy.gif',
//   devflow:  'https://media.giphy.com/media/13HgwGsXF0aiGY/giphy.gif',
//   finsight: 'https://media.giphy.com/media/l0HlBO7eyXzSZkJri/giphy.gif',
//   cloud:    'https://media.giphy.com/media/rHA6zm9rRSauk/giphy.gif',
//   about:    'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExd25iZWNlYXZhZmgwajJsMm1zN2txenp6emw3bDl1bmhqMTA3NTNwbCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/VZf1QNCHWl2qk/giphy.gif',
//   skills:   'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExd25iZWNlYXZhZmgwajJsMm1zN2txenp6emw3bDl1bmhqMTA3NTNwbCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/rHA6zm9rRSauk/giphy.gif',
//   exp:      'https://i.pinimg.com/1200x/69/66/16/696616c0acf73f6027e6f9ee0c29a49f.jpg',
// };


const PROJECT_ID = 'portfolio-e79b8-5854c';
export const API_KEY    = 'AIzaSyDLsmnqt6wth0b3hZYrnllXnJIcjUaK8Uc';
export const REST_BASE  = `https://firestore.googleapis.com/v1/projects/${PROJECT_ID}/databases/(default)/documents`;

// ── Deserializer: Firestore REST format → JS ──────────────────────────────────

function fromValue(v) {
  if (!v) return null;
  if ('stringValue'  in v) return v.stringValue;
  if ('integerValue' in v) return Number(v.integerValue);
  if ('doubleValue'  in v) return Number(v.doubleValue);
  if ('booleanValue' in v) return v.booleanValue;
  if ('nullValue'    in v) return null;
  if ('arrayValue'   in v) return (v.arrayValue.values || []).map(fromValue);
  if ('mapValue'     in v) return fromFields(v.mapValue.fields || {});
  return null;
}

function fromFields(fields) {
  const obj = {};
  for (const [k, v] of Object.entries(fields)) obj[k] = fromValue(v);
  return obj;
}

// ── Core fetch helpers ────────────────────────────────────────────────────────

async function fetchCollection(col, orderBy = null) {
  let url = `${REST_BASE}/${col}?key=${API_KEY}`;
  if (orderBy) url += `&orderBy=${encodeURIComponent(orderBy)}`;
  const res = await fetch(url);
  if (res.status === 404) return [];
  if (!res.ok) throw new Error(`Firestore ${col}: ${res.status}`);
  const json = await res.json();
  if (!json.documents) return [];
  return json.documents.map(d => ({
    id: d.name.split('/').pop(),
    ...fromFields(d.fields || {}),
  }));
}

async function fetchDocument(col, docId) {
  const url = `${REST_BASE}/${col}/${docId}?key=${API_KEY}`;
  const res = await fetch(url);
  if (!res.ok) return null;
  const json = await res.json();
  return { id: docId, ...fromFields(json.fields || {}) };
}

// ── Public fetch functions ────────────────────────────────────────────────────

export async function fetchProjects() {
  return fetchCollection('projects', 'order');
}

export async function fetchSkillGroups() {
  const data = await fetchCollection('skillGroups');
  return data.map(g => ({
    ...g,
    items: (g.items || []).map(item =>
      Array.isArray(item) ? item : [item.name, item.level]
    ),
  }));
}

export async function fetchExperiences() {
  return fetchCollection('experiences', 'order');
}

export async function fetchAbout() {
  return fetchDocument('about', 'main');
}

export async function fetchCertificates() {
  return fetchCollection('certificates', 'order');
}

export async function fetchReviews() {
  return fetchCollection('reviews', 'order');
}

// ── Blogs: reads the `blogs` collection ordered by `order` ───────────────────
// Each document shape:
//   { tag, color, title, excerpt, date, readTime, cover, order, published }
//
// Only documents where published === true are shown on the portfolio.
// The admin panel shows ALL documents (drafts + published).

export async function fetchBlogs() {
  const posts = await fetchCollection('blogs', 'order');
  // Return only published posts to the portfolio
  return posts.filter(p => p.published === true);
}

// ── Theme: reads the `theme/colors` document ──────────────────────────────────

export async function fetchTheme() {
  const url = `${REST_BASE}/theme/colors?key=${API_KEY}`;
  const res = await fetch(url);
  if (res.status === 404) return null;
  if (!res.ok) return null;
  const json = await res.json();
  const fields = json.fields || {};
  return Object.fromEntries(
    Object.entries(fields).map(([k, v]) => [k, v.stringValue || ''])
  );
}

// ── Projects Outro Quote: reads `projectsMeta/quote` document ─────────────────
// Document shape stored in Firestore:
//   { lines: ["line one,", "line two."], attribution: "— Someone" }
//
// Returns: { lines: string[], attribution: string }
// Falls back to hardcoded defaults if the document doesn't exist yet.
// ── Skills Meta: reads `skillsMeta/main` document ─────────────────────────────
// Document shape: { floatingImage: string }
// Falls back to the original hardcoded URL if the document doesn't exist.

// ── Skills Meta: reads `skillsMeta/main` ─────────────────────────────────────
// Document shape: { floatingImage: string, desktopWidthVw: number, mobileWidthVw: number }
//
// Firestore REST stores integers as { integerValue: "22" } (a string).
// fromFields() in data.js already handles this via Number(v.integerValue),
// but we explicitly Number() here as a safety net.

const DEFAULT_SKILLS_META = {
  floatingImage:  'https://izeiyujebczudhvsvbon.supabase.co/storage/v1/object/public/bucket/uploads/1781433720850_db5s8x4rqks.png',
  desktopWidthVw: 22,
  mobileWidthVw:  48,
};

export async function fetchSkillsMeta() {
  try {
    const url = `${REST_BASE}/skillsMeta/main?key=${API_KEY}`;
    const res = await fetch(url);
    if (res.status === 404) return { ...DEFAULT_SKILLS_META };
    if (!res.ok)            return { ...DEFAULT_SKILLS_META };

    const json   = await res.json();
    const fields = json.fields || {};
    const data   = fromFields(fields);   // uses the existing fromFields in data.js

    return {
      floatingImage:  typeof data.floatingImage  === 'string' ? data.floatingImage  : DEFAULT_SKILLS_META.floatingImage,
      desktopWidthVw: data.desktopWidthVw != null              ? Number(data.desktopWidthVw) : DEFAULT_SKILLS_META.desktopWidthVw,
      mobileWidthVw:  data.mobileWidthVw  != null              ? Number(data.mobileWidthVw)  : DEFAULT_SKILLS_META.mobileWidthVw,
    };
  } catch {
    return { ...DEFAULT_SKILLS_META };
  }
}
const DEFAULT_QUOTE = {
  lines:       ['about what you add,', 'but what you leave out.'],
  attribution: '',
};

export async function fetchProjectsQuote() {
  const url = `${REST_BASE}/projectsMeta/quote?key=${API_KEY}`;
  const res = await fetch(url);
  if (res.status === 404) return DEFAULT_QUOTE;
  if (!res.ok)            return DEFAULT_QUOTE;
  const json   = await res.json();
  const fields = json.fields || {};
  const data   = fromFields(fields);

  const lines       = Array.isArray(data.lines) ? data.lines.filter(Boolean) : DEFAULT_QUOTE.lines;
  const attribution = typeof data.attribution === 'string' && data.attribution.trim()
    ? data.attribution
    : DEFAULT_QUOTE.attribution;

  return { lines, attribution };
}

// ── Static assets (not in Firestore) ─────────────────────────────────────────

export const IMG = {
  neural:   'https://media.giphy.com/media/26tn33aiTi1jkl6H6/giphy.gif',
  devflow:  'https://media.giphy.com/media/13HgwGsXF0aiGY/giphy.gif',
  finsight: 'https://media.giphy.com/media/l0HlBO7eyXzSZkJri/giphy.gif',
  cloud:    'https://media.giphy.com/media/rHA6zm9rRSauk/giphy.gif',
  about:    'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExd25iZWNlYXZhZmgwajJsMm1zN2txenp6emw3bDl1bmhqMTA3NTNwbCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/VZf1QNCHWl2qk/giphy.gif',
  skills:   'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExd25iZWNlYXZhZmgwajJsMm1zN2txenp6emw3bDl1bmhqMTA3NTNwbCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/rHA6zm9rRSauk/giphy.gif',
  exp:      'https://i.pinimg.com/1200x/69/66/16/696616c0acf73f6027e6f9ee0c29a49f.jpg',
};